import { useGet } from './useHttpHooks';
import { Page } from '../types';
import toQuery from '../lib/toQuery';

type GetPageQuery = {
    questionId: number;
    questionText: string;
};

const useGetPage = (request: GetPageQuery) =>
    useGet<Page>(`/api/help-page?${toQuery(request)}`, {
        errorMessage: 'GET /api/help-page'
    });

export default useGetPage;
